const Moment = require('moment');

const DATETIME_UTILITY = {
    getCurrentDateTime: () => {
        return Moment();
    },
    parseDateTimeFromUTC: (datetime) => {
        return Moment(datetime);
    },
    getDaysToSpecificDateTime: (specificDateTime, formatDuration = (count, unit, backup) => backup) => {
        let v = 0;
        v = Moment(specificDateTime).diff(Moment(), 'days');
        if (v === 0) {
            v = Moment(specificDateTime).diff(Moment(), 'hours');
            if (v === 0) {
                v = Moment(specificDateTime).diff(Moment(), 'minute');
                if (v === 0) {
                    v = Moment(specificDateTime).diff(Moment(), 'second');
                    return formatDuration(v, 'seconds', `${v} seconds`);
                } else {
                    if (v > 1) return formatDuration(v, 'minutes', `${v} minutes`);
                    return formatDuration(v, 'minutes', `${v} minute`);
                }
            } else {
                if (v > 1) return formatDuration(v, 'hours', `${v} hours`);
                return formatDuration(v, 'hours', `${v} hour`);
            }
        } else {
            if (v > 1) return formatDuration(v, 'days', `${v} days`);
            return formatDuration(v, 'days', `${v} day`);
        }
    },
};

export default DATETIME_UTILITY;